import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { faArrowRightArrowLeft, faXmark } from "@fortawesome/pro-regular-svg-icons";

import { JobTitleVerdict } from "@signalist/shared-types";

import { Icon } from "@/components/Icon/Icon";

interface JobTitleSelectionToastProps {
	count: number;
	/** The column the selection lives in; the move goes to the opposite verdict. */
	selectionColumn: JobTitleVerdict;
	onMove: () => void;
	onClear: () => void;
}

export const JobTitleSelectionToast: FunctionComponent<JobTitleSelectionToastProps> = ({
	count,
	selectionColumn,
	onMove,
	onClear,
}) => {
	const { t } = useTranslation();

	if (count === 0) {
		return null;
	}

	// Moving out of the whitelist means excluding, and vice versa.
	const moveLabel = t(
		selectionColumn === JobTitleVerdict.WHITELISTED
			? "leadScoring.jobTitles.moveToExcluded"
			: "leadScoring.jobTitles.moveToWhitelisted"
	);

	return (
		<div
			className="fixed bottom-6 left-1/2 z-50 flex -translate-x-1/2 items-center gap-4 rounded-xl border border-gray-200 bg-white px-4 py-3 shadow-lg"
			data-test="job-title-selection-toast"
		>
			<span className="text-sm font-semibold text-text" data-test="job-title-selection-count">
				{t("leadScoring.jobTitles.selected", { count })}
			</span>
			<button
				className="flex cursor-pointer items-center gap-2 rounded-lg bg-brand-light px-3 py-1.5 text-xs font-semibold text-white hover:opacity-90"
				data-test="job-title-move-selected"
				type="button"
				onClick={onMove}
			>
				<Icon className="h-3.5 w-3.5" icon={faArrowRightArrowLeft} />
				{moveLabel}
			</button>
			<button
				aria-label={t("leadScoring.jobTitles.clearSelection")}
				className="flex cursor-pointer items-center gap-1 text-xs font-medium text-text-meta hover:text-text"
				data-test="job-title-clear-selection"
				type="button"
				onClick={onClear}
			>
				<Icon className="h-3.5 w-3.5" icon={faXmark} />
				{t("leadScoring.jobTitles.clearSelection")}
			</button>
		</div>
	);
};
